import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KkmDatepickerComponent } from './kkm-datepicker.component';
import { KkmCalendarComponent } from './kkm-calendar/kkm-calendar.component';
import { MatIconModule } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KkmMultiYearViewComponent } from './kkm-multi-year-view/kkm-multi-year-view.component';
import { KkmQuarterViewComponent } from './kkm-quarter-view/kkm-quarter-view.component';
import { PortalModule } from '@angular/cdk/portal';
import { KkmCalendarHeaderComponent } from './kkm-calendar-header/kkm-calendar-header.component';
import { A11yModule } from '@angular/cdk/a11y';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    KkmDatepickerComponent,
    KkmCalendarComponent,
    KkmMultiYearViewComponent,
    KkmQuarterViewComponent,
    KkmCalendarHeaderComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    OverlayModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    PortalModule,
    A11yModule,
    TranslocoModule,
  ],
  exports: [
    KkmDatepickerComponent,
  ],
})
export class KkmDatepickerModule { }
